
export default function Start(props) {
    return (
        <div className="start">
            <h1>Quizzical</h1>
            <p>Do you dare to test your Knowledge?</p>
            <button className="btn welcome--btn" onClick={props.startQuiz}>
                Start quiz
            </button>
        </div>
    )
}
    /* end of start component */
